<!-- Start Breadcrumb -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light" style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>Refund Policy</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>Policies</li>
          <li>Refund Policy</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->

<div class="services-details-area overflow-hidden default-padding">
  <div class="container">
    <div class="services-details-items">
      <div class="row">

        <div class="col-xl-8 col-lg-7 order-lg-last pl-50 pl-md-15 pl-xs-15">
          <div class="content-style-one">
            <h2>Refund Policy</h2>
            <p>
              Software subscriptions are generally non-refundable after activation.
            </p>
            <p>
              Custom software development payments are non-refundable once work has commenced.
            </p>
            <p>
              Institution fee payments collected through our platform are subject to the refund policy of the respective school, college or organization.
            </p>
            <p>
              Verified duplicate or erroneous transactions will be refunded within 7–10 business days to the original payment method.
            </p>
            <p>
              Failed transactions are normally auto-reversed by the bank. Contact support if reversal does not occur.
            </p>
          </div>
        </div>

        <div class="col-xl-4 col-lg-5 mt-md-120 mt-xs-50 services-sidebar">
          <div class="single-widget services-list-widget">
            <h4 class="widget-title">Policies</h4>
            <div class="content">
              <ul>
                <li routerLinkActive="current-item"><a routerLink="/policies/terms-and-conditions">Terms and conditions</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/privacy-policy">Privacy Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/refund-policy">Refund Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/cancellation-policy">Cancellation Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
